import { ref } from 'vue'

export const useImageSourceDialog = () => {
  const selectedSource = ref('customer-web')
  const showSourceDialog = ref(false)

  // Valid source options that exist in the dialog
  const validSources = [
    'customer-web',
    'snappr',
    'third-party-dd',
    'third-party-ue',
    'third-party-gh',
    'third-party-other',
    'unknown',
  ]

  const openSourceDialog = (currentSource?: string | null) => {
    // Set selectedSource to current source if it's valid, otherwise default to 'customer-web'
    if (currentSource && validSources.includes(currentSource)) {
      selectedSource.value = currentSource
    } else {
      selectedSource.value = 'customer-web'
    }
    showSourceDialog.value = true
  }

  const closeSourceDialog = () => {
    showSourceDialog.value = false
  }

  const resetSource = () => {
    selectedSource.value = 'customer-web'
  }

  return {
    closeSourceDialog,
    openSourceDialog,
    resetSource,
    selectedSource,
    showSourceDialog,
  }
}
